module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "Fifteen Things I’ve Noticed While Trying to Walk 10,000 Steps Per Day"
    }
  }, [_c('p', {
    staticClass: "image0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ach02"
    }
  }, [_vm._v("FIFTEEN THINGS I’VE NOTICED WHILE TRYING TO WALK 10,000 STEPS PER DAY")])]), _vm._v(" "), _c('p', {
    staticClass: "cst"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ach02"
    }
  }, [_vm._v("Muncie, Indiana Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "au"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ach02"
    }
  }, [_vm._v("SILAS HANSEN")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("1.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On a cold and rainy Sunday afternoon when I didn’t want to walk outside: a box proclaiming to be synthetic urine for sale in Nirvana, next to Louie’s Tux Shop and across from C. J. Banks in the Muncie Mall, behind the counter where they sell glass pipes blown to resemble tiny carrots and octopi, next to a rack of Rasta wigs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("2.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On my walk between my house and my favorite bar, in the ninety-degree angle created by a lamppost and a banner proclaiming this path to be the Fallen Heroes Memorial Bridge: a gigantic orb-weaver spider and its perfect web that catches the setting sun as I walk by.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("3.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On a snowy Friday night in January, on my walk to play euchre with friends: an undergrad standing in the snow, dressed in a pair of gym shorts, snow boots, and a black North Face, holding a PBR tallboy in one hand and a leash in the other, connecting him to a tiny, fluffy white dog, nearly hidden in snow up to its belly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("4.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On the corner of Jackson and High Street, across from the MITS bus station: a single glass jar of Prego tomato sauce—shattered, red splattered across the sidewalk.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("5.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The sound of a train whistle off in the distance, announcing itself as it barrels along the railroad tracks that run through and all around the city, sounding eerie and inviting all at once.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("6.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A rundown pickup truck full of drunk guys—too old to be called boys, too young yet to be called men—one of whom yells, “I’m going to fuck you up! I’m going to FUCK! YOU! UP!” as they speed by, the others laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("7.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A man, standing proudly on his porch at 11:00 p.m. on a Thursday evening while music blasts from inside his house; and then, as I get closer: the stream of urine as he makes eye contact and nods to acknowledge my presence—unashamed, unabashed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("8.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A man in his late fifties or early sixties, dressed like Elvis—rhinestone-studded suit and all—and singing Neil Diamond’s “Sweet Caroline” in front of the yoga studio while a group of young women, college-aged, hula hoop around him.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("9.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A sign stuck in the grass in front of the Phillips 66 gas station around the corner from my house: yellow corrugated plastic with black sans serif letters: “WALT’S CRAWLERS.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("10.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A college student wearing gym shorts, no shirt, and a fuzzy animal head—an otter, perhaps—while skateboarding in the faculty parking lot on a Friday afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("11.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the parking lot of the liquor store where I buy overpriced, mediocre wine when I don’t want to drive to Aldi: an exact replica of the Jurassic Park jeep, windows down, no one inside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("12.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("During the monthly art walk through downtown: a man with a face tattoo, advertising his wife’s massage business by walking up and down the street in "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("front of the Mexican restaurant, holding a sign advertising $1 massages and “MAGIC FINGERS.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("13.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On my way home from trivia on a Tuesday night at about 11:00 p.m.: a thirtysomething man in an Alan Iverson jersey, powerwalking while drinking a bright red slushy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("14.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A squirrel skull and tibia ribs held in a glass case, $30 in the Downtown Flea Market and Oddities Shop.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("15.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Two grown men standing in the parking lot in front of Dollar Tree, next to a rundown pickup truck, silently releasing six balloons into the sky, one by one, and watching them float away.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48a30a13","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter02.vue
// module id = 81
// module chunks = 0